import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { DATE_FORMAT } from '#client/constants/date';
import { TRANSACTION_DIRECTION } from '#client/constants/transaction';

import CardUsed from './CardUsed';
import FieldDetail from './FieldDetail';
import MoneyDetail from './MoneyDetail';

export default function TransactionDetail({
  amount,
  createdAt,
  balanceAmount,
  type,
  id,
  traceNumber,
  reason,
  cardId,
  description,
  merchantName,
  direction
}) {
  const createdAtText = dayjs(createdAt).format(DATE_FORMAT.MOVE_MONEY);
  const isAstraTransaction =
    direction === TRANSACTION_DIRECTION.CREDIT && merchantName?.toLowerCase().includes('astra');

  return (
    <Grid
      columnSpacing="8px"
      container
      pb={{ xs: '24px', md: '56px' }}
      pt={{ xs: '24px', md: '32px' }}
      px={{ xs: '24px', md: '32px' }}
      rowSpacing={{ xs: '16px', md: '32px' }}
    >
      <Grid
        item
        xs={12}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Text
            color="primary"
            size="xl"
            weight="medium"
          >
            Transaction details
          </Text>
        </Stack>
      </Grid>
      <Grid
        item
        xs={12}
      >
        <Grid container>
          <MoneyDetail
            label="Amount"
            value={amount}
          />
        </Grid>
      </Grid>
      <FieldDetail
        label="Date Completed"
        value={createdAtText}
      />
      <FieldDetail
        label="Transaction Type"
        value={type}
      />
      <FieldDetail
        label="Account Balance"
        value={balanceAmount}
      />
      <FieldDetail
        label="Transaction Description"
        value={description}
      />
      <FieldDetail
        label="Transaction ID"
        value={id}
      />
      <FieldDetail
        label="Trace Number"
        value={traceNumber}
      />
      <FieldDetail
        label="Reason"
        value={reason}
      />
      {!isAstraTransaction && <CardUsed cardId={cardId} />}
    </Grid>
  );
}

TransactionDetail.propTypes = {
  amount: PropTypes.string,
  createdAt: PropTypes.string,
  type: PropTypes.string,
  balanceAmount: PropTypes.string,
  id: PropTypes.string,
  traceNumber: PropTypes.string,
  reason: PropTypes.string,
  cardId: PropTypes.string,
  description: PropTypes.string,
  merchantName: PropTypes.string,
  direction: PropTypes.string
};
